<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { axiosGetPost } from '@router/axiosGetPost'
import HideColumnsTable from '@components/datatablegn/HideColumnsTable'
import AddMetricsExport from '@components/managements/AddMetricsExport'

export default {
  page: {
    title: 'Export Metrics',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, AddMetricsExport, HideColumnsTable },
  data() {
    return {
      title: 'Export Metrics',
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Management',
          active: false,
        },
        {
          text: 'Export Metrics',
          active: false,
        },
      ],
      typeTable: 'exportMetrics',
      tableData: [{ data: 'ok' }],
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'id',
      sortDesc: true,
      fields: [],
      fieldList: [],
      excludeFields: [],
      loadingTable: true,
      modalComponent: 'AddMetricsExport',
      modalTitle: 'Request Metrics',
      modalError: null,
      modalErrorShow: false,
      showModal: false,
      loadingData: false,
      rowId: null,
    }
  },
  computed: {
    rows() {
      return this.tableData.length
    },
  },
  created() {
    this.fetchData()
    this.totalRows = this.tableData.length
  },
  watch: {
    filter(newValue) {
      localStorage.setItem('searchMetricsList', newValue)
    },
  },
  mounted() {
    const searchValue = localStorage.getItem('searchMetricsList')
    if (searchValue) {
      this.filter = searchValue
    }
  },
  methods: {
    fetchData() {
      this.loadingTable = true
      this.time = 0

      axiosGetPost('get', '/metricsApp/list').then((response) => {
        console.log(response)
        const data = response
        this.fieldList = data.data[1]
        this.tableData = data.data[0]
        this.loadingTable = false
        return data
      })
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
    },
    customFilterTable(row, filter) {
      let valuesRow = Object.values(row)
      //console.log(values)
      let filtersSp = filter.split(' ')
      const filtersFined = []
      filtersSp.forEach((filterVal) => {
        valuesRow.filter((valRow) => {
          let valRowLC = String(valRow).toLowerCase()
          let filterValLC = String(filterVal).toLowerCase()
          if (valRowLC.includes(filterValLC)) {
            if (!filtersFined.includes(filterVal)) filtersFined.push(filterVal)
          }
        })
      })

      return filtersFined.length === filtersSp.length
    },
    addNew() {
      this.showModal = true
      this.modalComponent = 'AddMetricsExport'
      this.modalTitle = 'Request Export Metrics'
      this.modalError = null
      this.modalErrorShow = false
    },
    saveModal() {
      this.showModal = false
      this.fetchData()
    },
    downloadFile(id) {
      axiosGetPost('get', '/metricsApp/download/' + id).then((response) => {
        if (response.success) {
          let link = document.createElement('a')
          link.setAttribute('target', '_blank')
          link.href = response.url
          link.click()
          URL.revokeObjectURL(link.href)
          this.$toastr.s('Success Download File')
        } else {
          this.$toastr.e('Error Download File')
        }
      })
    },
    updateTableFieldsEmit(fields) {
      this.fields = fields
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-md-2">
              <div class="col-sm-3 col-md-8 text-md-left">
                <h4 class="header-title mt-0 mb-1">Request Metrics Export</h4>
              </div>
              <div class="col-sm-4 col-md-4 text-md-right">
                <b-button
                  class="btn btn-primary col-md-5"
                  variant="primary"
                  @click="addNew"
                  >Add <i class="uil uil-plus"></i>
                </b-button>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-12">
                <div class="d-flex mb-md-2">
                  <!-- Inicio Table */******************************************************* */ -->
                  <div class="mr-auto">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Inicio Ocultar columnsas /********************/**************-->
                  <div>
                    <HideColumnsTable
                      v-if="this.loadingTable === false"
                      :field-list-fth="fieldList"
                      :type-table="typeTable"
                      @updateTableFieldsEmit="updateTableFieldsEmit"
                    />
                  </div>
                  <!-- Fin Ocultar columnsas /********************/**************-->
                  <!-- Search -->
                  <div>
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                  </div>

                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                    striped
                    hover
                    :items="tableData"
                    :fields="fields"
                    responsive="sm"
                    :busy="loadingTable"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :filter-function="customFilterTable"
                    @filtered="onFiltered"
                  >
                    <template v-slot:table-busy>
                      <div
                        class="row align-items-center justify-content-center"
                        style="height: 150px"
                      >
                        <div class="col-12 col-md-8 text-center">
                          <b-spinner
                            label="Loading..."
                            variant="primary"
                            class="ml-3"
                          ></b-spinner>
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell(status)="row">
                      <div v-if="row.item.status === 'Done'">
                        <span class="badge badge-soft-success">{{
                          row.item.status
                        }}</span>
                      </div>
                      <div v-else-if="row.item.status === 'Pending'">
                        <span class="badge badge-soft-error">{{
                          row.item.status
                        }}</span>
                      </div>
                    </template>
                    <template v-slot:cell(actions)="row">
                      <div>
                        <b-dropdown
                          variant="success"
                          dropleft
                          class="ml-1 btn-sm"
                          :ref="`actions_dropdown_${row.item.id}`"
                        >
                          <template slot="button-content">
                            <i
                              class="uil uil-angle-double-left"
                              style="color: #278c27"
                            ></i>
                            <i>Options</i>
                          </template>
                          <b-dropdown-item
                            href="#"
                            style="color: ##0a399a"
                            v-if="row.item.status === 'Done'"
                            @click="downloadFile(row.item.id)"
                          >
                            <span style="color: rgb(1 38 113)"
                              ><i class="uil uil-cloud-download"></i>&nbsp;
                              &nbsp; Download</span
                            >
                          </b-dropdown-item>
                          <b-dropdown-item
                            href="#"
                            style="color: ##0a399a"
                            v-if="row.item.status !== 'Done'"
                          >
                            <span style="color: rgb(1 38 113)"
                              ><i class="uil uil-times-circle"></i>&nbsp; Not
                              Available</span
                            >
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <strong
                      >Filtered {{ totalRows }} of {{ rows }} entries</strong
                    >
                    <div
                      class="dataTables_paginate paging_simple_numbers float-lefts"
                    ></div>
                  </div>
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-right"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Fin Table */******************************************************* */ -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id="modal-lg"
        ref="requestFcl"
        v-model="showModal"
        size="lg"
        :title="modalTitle"
        title-class="font-18"
      >
        <div
          v-if="loadingData"
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <b-spinner
              label="Loading..."
              variant="primary"
              class="ml-3"
            ></b-spinner>
          </div>
        </div>

        <div v-else-if="modalErrorShow === true">
          <div
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather type="frown" class="icon-xxl icon-dual-info"></feather>
              <h6 class="text-muted">{{ modalError }}</h6>
            </div>
          </div>
        </div>

        <AddMetricsExport
          v-if="modalComponent === 'AddMetricsExport'"
          @close_modal="saveModal"
        />

        <template v-slot:modal-footer>
          <b-button variant="light" @click="$refs.requestFcl.hide"
            >Close</b-button
          >
        </template>
      </b-modal>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style>
.table-responsive-list-menu {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

.badge-soft-warning {
  color: #c39411 !important;
  background-color: rgba(255, 190, 11, 0.2);
}

.badge-soft-success {
  color: #299a70 !important;
  background-color: rgba(67, 211, 158, 0.2);
}
.badge-soft-error {
  color: #e40707 !important;
  background-color: rgba(190, 5, 5, 0.116);
}

.badge-tier-1 {
  color: #ffffff !important;
  background-color: #1f56d6;
}

.badge-tier-2 {
  color: #ffffff !important;
  background-color: #1f93d6;
}

.badge-tier-3 {
  color: #ffffff !important;
  background-color: #1dbfd7;
}

.btn-success:hover {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.btn-success {
  color: #0014a2;
  background-color: #ffffff;
  border-color: #031b4e;
}

.show .btn-success.dropdown-toggle {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.text {
  font-family: helvetica;
  font-weight: bold;
  color: #71d90b;
}
</style>
